import { useCallback } from 'react';

import { useUpdateCurrentWorkspaceMutation } from '@/features/workspaces/api/workspacesApi';
import { setCurrentWorkspace } from '@/features/workspaces/slices/workspacesSlice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { notify } from '@web/utils';

import type { UpdateCurrentWorkspacePayload } from '@/features/workspaces/types';

export function useUpdateCurrentWorkspace() {
  const dispatch = useAppDispatch();
  const currentWorkspace = useAppSelector(
    (state) => state.workspaces.currentWorkspace,
  );
  const [mutate, { isLoading }] = useUpdateCurrentWorkspaceMutation();

  const update = useCallback(
    async (payload: UpdateCurrentWorkspacePayload) => {
      const res = await mutate(payload).unwrap();
      if (res.success) {
        dispatch(
          setCurrentWorkspace({
            ...(currentWorkspace ?? {}),
            ...res.data,
          }),
        );

        notify({
          message: res.message || 'Workspace updated',
          type: 'success',
        });
      } else {
        notify({
          message: res.message || 'Failed to update workspace',
          type: 'error',
        });
      }
      return res;
    },
    [currentWorkspace, dispatch, mutate],
  );

  return { update, isLoading };
}
